import isURL from 'validator/lib/isURL';

import { TFunction } from '@lyearn/i18n';
import { ExternalEventCreationStrategyEnum, ExternalEventProviderInfoInput } from '@/types/schema';

import { getProviderMetaObj } from '../../../utils';
import { ExternalEventProviderType } from '../types';

export const LY_EVENT_URL_KEY = 'lyEventUrl';

export const getProvider = (providerId: string, providers?: ExternalEventProviderType[]) => {
  return providers?.find((provider) => provider.value === providerId);
};

export const isExternalProviderUrlValid = (
  externalEventProviderInfo?: ExternalEventProviderInfoInput | null,
) => {
  if (!externalEventProviderInfo?.meta) {
    return true;
  }
  const meta = getProviderMetaObj(externalEventProviderInfo);
  const url = meta[LY_EVENT_URL_KEY];

  if (!url) {
    return true;
  }

  if (!isURL(url, { require_protocol: true, protocols: ['http', 'https'] })) {
    return true;
  }

  return false;
};

export const isExternalProviderEmpty = (
  externalEventProviderInfo?: ExternalEventProviderInfoInput | null,
) => {
  if (!externalEventProviderInfo?.providerId) {
    return true;
  }

  return false;
};

export const getCreationStrategyOptions = (t: TFunction) => {
  return [
    {
      value: ExternalEventCreationStrategyEnum.Integration,
      label: t('Events:AutomaticallyCreateMeeting'),
    },
    {
      value: ExternalEventCreationStrategyEnum.Form,
      label: t('Events:ManuallyAddMeetingDetails'),
    },
  ];
};
